const formatClassName = (array) => array.filter(Boolean).join(" ");

export default formatClassName;
